import { z } from 'zod'

export const ArchivableSchema = z.object({
  isDeleted: z.boolean().optional().meta({
    id: 'isDeleted',
    description: 'Indicates if the item is deleted',
  }), // Consider using a timestamp
})
export type Archivable = z.infer<typeof ArchivableSchema>

export const ArchivedFilterSchema = z.union([z.boolean(), z.literal('all')])
export type ArchivedFilter = true | false | 'all'

export const WithArchivedFilterSchema = z.object({
  archived: ArchivedFilterSchema.optional().meta({
    id: 'archived',
    description: 'Whether to include archived items. If "all", include archived items as well as non-archived items.',
  }),
})
export type WithArchivedFilter = z.infer<typeof WithArchivedFilterSchema>
